module.exports = __webpack_public_path__ + "images/photoshoot2-5744cef9a59fb7df6194c0937c2e17dd.jpg";